module.exports = __webpack_public_path__ + "img/logo.16b4d442.png";